<template>
  <div class="md-scrollbar performances">
     <div class="filter-wrapper">
     <div class="inputs-wrapper">
        <h3>Filter</h3>
        <md-radio v-model="filter" :value="'play'">Po predstavi</md-radio>
        <md-radio v-model="filter" :value="'date'">Po datumu</md-radio>
      </div>
      <div class="inputs-wrapper" v-if="filter == 'play'">
        <h3>Predstava</h3>
        <Autocomplete v-model="playID" :stateObject="'plays'" :searchBy="'title'" :returnField="'id'" :label="'Odaberi predstavu'"/>
      </div>
      <div class="inputs-wrapper" v-if="filter == 'date'">
        <h3>Period</h3>
        <md-datepicker v-model="period.from">
          <label>Od</label>
        </md-datepicker>
        <md-datepicker v-model="period.to">
          <label>Do</label>
        </md-datepicker>
      </div>
      <div class="inputs-wrapper">
        <h3>Datum izvođenja</h3>
        <md-radio v-model="isActive" :value="1">Aktivne</md-radio>
        <md-radio v-model="isActive" :value="0">Prošle</md-radio>
      </div>
      <div class="inputs-wrapper with-button">
        <md-button class="md-raised md-dense md-primary" v-on:click="filterTransactions()">Prikaži</md-button>
        <md-button class="md-raised md-dense md-accent" :disabled="!searched" v-on:click="clear()">Poništi</md-button>
      </div>
    </div>
    <div ref="performancesPrint">
    <md-table v-if="$store.state.pageLoaded" class="performances-table" v-model="$store.state.receivedData.performances.list">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent print-hidden" v-on:click="editCreateDialogVisible = true; createDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptyPerformance));" title="Dodaj u raspored"  v-if="$store.state.schema.performance.create">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Raspored</h1>
        </div>
      </md-table-toolbar>

      <md-table-row md-selectable="single" md-auto-select slot="md-table-row" slot-scope="{ item }" v-bind:class="{ cancelled: item.is_cancelled }">
        <md-table-cell md-label="Predstava" md-sort-by="play_title">{{ item.play_title }}</md-table-cell>
        <md-table-cell md-label="Pozornica" md-sort-by="stage">{{ getTitle('stages', item.stage) }}</md-table-cell>
        <md-table-cell md-label="Pretplata">
          <span v-if="item.occupied_rows.hasOwnProperty('subscription')">
            <span v-for="subscription, key in item.occupied_rows.subscription">
              {{ getSubscriptionTitle(key) }}
            </span>
          </span>
        </md-table-cell>
        <md-table-cell md-label="Cjenik" md-sort-by="pricelist_title">{{ item.pricelist_title }}</md-table-cell>
        <md-table-cell md-label="Datum i vrijeme" md-sort-by="start_time">{{ parseDate(item.start_time) }}</md-table-cell>
        <md-table-cell md-label="Aktivnost" md-sort-by="start_time">{{ item.activity }}</md-table-cell>
        <md-table-cell md-label="Objavljeno" class="print-hidden">
          <md-icon v-if="item.published" class="color-green">done</md-icon>
          <md-icon v-else class="color-red">not_interested</md-icon>
        </md-table-cell>
        <md-table-cell md-label="Live stream" class="print-hidden">
          <md-icon v-if="item.is_live" class="color-green">done</md-icon>
          <md-icon v-else class="color-red">not_interested</md-icon>
        </md-table-cell>
        <md-table-cell md-label="Slobodno/Prodano">{{ parseInt(item.available) + parseInt(item.total_extra_seats) }}/{{ (parseInt(item.sold) + parseInt(item.sold_extra_seats)) }}</md-table-cell>
        <md-table-cell md-label="Link" class="print-hidden">
        <md-button class="md-icon-button v-align-middle" v-on:click="copyToClipboard(`https://www.hnk.hr/hr/prodaja/predstava/${item.id}/`)" title="Kopiraj">
          <md-icon>file_copy</md-icon>
        </md-button>
        <a target="_blank" :href="`${$store.state.urls.ticketTheatreCopy}${item.id}/`">
          {{ `${$store.state.urls.ticketTheatreCopy}${item.id}/` }}
        </a>
        </md-table-cell>
        <md-table-cell class="t-align-center v-align-middle print-hidden">
          <!--<md-button class="md-dense md-primary md-raised" v-on:click="$store.state.dialogs.editTicketTheatre = true; $store.state.theatre.rows = item.rows; setStageKind(item.stage)" title="Uredi mjesta">
            Uredi mjesta
          </md-button>-->
          <md-button class="md-dense md-primary md-raised" v-on:click="$store.state.selectedObject = JSON.parse(JSON.stringify(item)); extendPricelist(item); editPricelist = true; " title="Uredi cjenik" v-if="$store.state.schema.performance.update">
            Uredi cjenik
          </md-button>
          <md-button class="md-dense md-primary md-raised" v-on:click="showTheatre(item)" title="Prikaži dvoranu">
            Prikaži dvoranu
          </md-button>
          <md-button class="md-icon-button md-accent" v-on:click="deleteDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(item))" title="Obriši" v-if="$store.state.schema.performance.delete">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-on:click="selectedPerformance = JSON.parse(JSON.stringify(item)); $store.state.selectedObject = JSON.parse(JSON.stringify(item)); editCreateDialogVisible = true; editDialog = true; createDialog = false" title="Uredi" v-if="$store.state.schema.performance.update">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    </div>

    <md-dialog-confirm :md-active.sync="deleteDialog"
                md-title="Brisanje iz rasporeda"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSelected"
                >
    </md-dialog-confirm>

    <md-dialog :md-active.sync="editCreateDialogVisible" v-if="$store.state.selectedObject !== undefined" class="md-scrollbar performance-dialog">
      <md-dialog-title>{{ getDialogTitle }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <Autocomplete v-model="$store.state.selectedObject.play" :stateObject="'plays'" :searchBy="'title'" :returnField="'id'" :label="'Odaberi predstavu'"/>
            <md-field :class="messageClass('start_time', $store.state.selectedObject)">
              <datetime class="md-field" type="datetime" v-model="$store.state.selectedObject.start_time"></datetime>
              <label>Datum</label>
            </md-field>
            <md-field :class="messageClass('pricelist', $store.state.selectedObject)" v-if="createDialog">
              <label>Cjenik</label>
              <md-select v-model="$store.state.selectedObject.pricelist">
                <md-option v-for="pricelist, i in $store.state.receivedData.pricelistsList.list" :value="pricelist.id">
                  {{ pricelist.title }}
                </md-option>
              </md-select>
            </md-field>
            <md-field :class="messageClass('season', $store.state.selectedObject)" v-if="createDialog">
              <label>Sezona</label>
              <md-select v-model="$store.state.selectedObject.season">
                <md-option v-for="season in $store.state.receivedData.seasonsList.list" :value="season.id">{{ season.title }}</md-option>
              </md-select>
            </md-field>
            <div v-if="createDialog">
              <md-checkbox v-for="subscription in $store.state.receivedData.subscriptionBundle.list" :value="subscription.id"  v-if="subscription.available_for_performance === true" v-model="$store.state.selectedObject.subscriptions">
                {{ subscription.title }}
              </md-checkbox>
            </div>
            <md-field :class="messageClass('stage', $store.state.selectedObject)" v-if="createDialog">
              <label>Dvorana</label>
              <md-select v-model="$store.state.selectedObject.stage">
                <md-option v-for="stage in $store.state.receivedData.stages.list" :value="stage.id">{{ stage.title }}</md-option>
              </md-select>
            </md-field>
            <md-field :class="messageClass('total_extra_seats', $store.state.selectedObject)">
              <label>Nenumerirana sjedala</label>
              <md-input v-model="$store.state.selectedObject.total_extra_seats"/>
            </md-field>
            <md-field :class="messageClass('activity', $store.state.selectedObject)">
              <label>Aktivnost</label>
              <md-input v-model="$store.state.selectedObject.activity"/>
            </md-field>
            <md-checkbox v-model="$store.state.selectedObject.published">
              Objavljeno
            </md-checkbox>
            <md-checkbox v-model="$store.state.selectedObject.is_cancelled">
		Otkazano
            </md-checkbox>
            <md-checkbox v-model="$store.state.selectedObject.is_live">
              Live stream
            </md-checkbox>
            <md-field :class="messageClass('live_price', $store.state.selectedObject)" v-if="$store.state.selectedObject.is_live">
              <label>Cijena Livestreama</label>
              <md-input v-model="$store.state.selectedObject.live_price" type="number"/>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="editCreateDialogVisible = false;">Zatvori</md-button>
            <md-button v-on:click="onCreate()" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>

    <md-dialog :md-active.sync="$store.state.dialogs.editTicketTheatre" class="theatre-dialog theatre-tickets-dialog md-scrollbar">
      <md-toolbar md-elevation="0">
        <md-button class="md-icon-button md-accent md-raised" v-on:click="$store.state.dialogs.editTicketTheatre = false;">
          <md-icon>close</md-icon>
        </md-button>
        <h3 class="md-title">Uredi mjesta - {{ getTitle('plays', $store.state.selectedObject.play) }} - {{ parseDate($store.state.selectedObject.start_time) }}</h3>
      </md-toolbar>
      <div class="theatre-container theatre-container-admin theatre-tickets">
        <AdminTheatre/>
      </div>
    </md-dialog>

    <md-dialog :md-active.sync="editPricelist" class="theatre-dialog md-scrollbar">
      <md-toolbar md-elevation="0">
        <md-button class="md-icon-button md-accent md-raised" v-on:click="editPricelist = false">
          <md-icon>close</md-icon>
        </md-button>
        <h3 class="md-title">Uredi cjenik - {{ getTitle('plays', $store.state.selectedObject.play) }} - {{ parseDate($store.state.selectedObject.start_time) }}</h3>
      </md-toolbar>
      <div class="theatre-container theatre-container-admin theatre-tickets">
         <md-card class="pricelist-table-inner">
          <md-card-content>
            <div class="md-layout">
                <md-table v-if="editPricelist">
                  <md-table-row>
                  <md-table-cell></md-table-cell>
                  <md-table-cell v-for="i in Array.from({length: 5}, (x,i) => i)">
                    <md-checkbox v-model="activeCategories" :value="i" :disabled="i == 1">
                      <span v-if="i == 0">Proscenij</span>
                      <span v-else>{{ i }}. kategorija</span>
                    </md-checkbox>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-for="discount in $store.state.receivedData.discounts.list">
                  <md-table-cell>
                    <md-checkbox v-model="activeDiscounts" :value="discount.id" :disabled="['regular'].includes(discount.kind)">
                      {{ discount.description }}
                    </md-checkbox>
                  </md-table-cell>
                  <md-table-cell v-for="category, categoryKey in $store.state.selectedObject.pricelist_data.category">
                    <md-field>
                    <md-input type="text" :disabled="!activeCategories.includes(parseInt(categoryKey)) || !activeDiscounts.includes(parseInt(discount.id))" v-model="$store.state.selectedObject.pricelist_data.category[categoryKey][discount.id]" v-on:input="recalculatePrice(discount.kind == 'regular', categoryKey, $store.state.selectedObject.pricelist_data.category[categoryKey][discount.id])"/>
                    </md-field>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
            <md-dialog-actions>
              <md-button v-on:click="onCreate" class="md-primary">Spremi</md-button>
            </md-dialog-actions>
          </md-card-content>
        </md-card>
      </div>
    </md-dialog>

    <TicketTheatre :fromPage="true" v-if="detailsVisible" @close="detailsVisible = false" class="details-page"/>

    <md-button class="md-primary md-dense md-raised fixed-print-btn" v-on:click="print($refs.performancesPrint)">
      Ispiši
    </md-button>
  </div>
</template>

<script>
import ListingMixin from '../../../mixins/listing-mixin.js'
import PricelistMixin from '../../../mixins/pricelist-mixin.js'
import Printd from 'printd'
import { mapGetters } from 'vuex';

export default {
  name: 'Performances',
  data(){
    return {
      filter: 'play',
      period: {
        to: new Date(),
        from: new Date(),
      },
      detailsVisible: false,
      isActive: 1,
      playID: '',
      start_time: '',
      searched: false,
      emptyPerformance: {},
      selectedPerformance: {},
      window: null,
      pageY: 0,
      document: null,
      editPricelist: false,
      showPricelist: false,
      requiredFields: ['start_time'],
    }
  },

  mixins: [ListingMixin('performances', 'u rasporedu'), PricelistMixin('pricelist_data')],

  computed:{
    ...mapGetters([
      'getSelectedSeats',
      'isPageLoaded',
    ])
  },

  mounted(){
    this.document = document;
    this.window = window;
    let input = this.document.createElement('input');
    input.setAttribute('class', 'copy-input');
    input.style.position = 'absolute';
    input.style.left = '999999px';
    this.document.body.appendChild(input);

    this.body = this.document.body;
    this.body.style.overflow = 'auto';
  },

  async created(){
    for(let i = 0; i < this.$store.state.receivedData.ticketTheatre.additionalSimpleGet.length; i++){
      await this.$store.dispatch('getData', ({
        url: this.$store.state.urls[this.$store.state.receivedData.ticketTheatre.additionalSimpleGet[i]],
        stateObject: this.$store.state.receivedData.ticketTheatre.additionalSimpleGet[i],
      }));
    }
  },

  methods:{
    getTitle(stateObject, id){
      let object = this.$store.state.receivedData[stateObject].list.filter((object) =>{return object.id == id})[0];
      return object !== undefined ? object.title : '';
    },

    print(component){
        let p = new Printd();
        p.print(component,[`
          *{
            font-family: 'Calibri';
            font-size: 16px;
          }

          h1{
            font-size: 30px;
            text-align: center;
            margin: 0 0 35px;
          }

          .print-hidden, th:nth-last-of-type(2), th:nth-last-of-type(4){
            display: none;
          }
          svg{
            display: none;
          }

          table{
            border-spacing: 0;
          }

          td, th{
            text-align: left;
            vertical-align: top;
            padding: 8px 5px;
            border-bottom: 1px solid #000;
          }
        `]);
    },

    getSubscriptionTitle(subscriptionID){
      for(let i = 0; i < this.$store.state.receivedData.subscriptionBundle.list.length; i++){
        if(this.$store.state.receivedData.subscriptionBundle.list[i].id == subscriptionID){
          return this.$store.state.receivedData.subscriptionBundle.list[i].title;
          break;
        }
      }
    },

    parseDate(date){
      if(date !== undefined){
        let selectedDate = new Date(date).toLocaleString('hr-HR');
	let d = new Date(date);
	let weekday = ['Nedjelja', 'Ponedjeljak', 'Utorak', 'Srijeda', 'Četvrtak', 'Petak', 'Subota']
        return `${selectedDate.substring(0, selectedDate.length-3)} ${weekday[d.getDay()]}`
      }
    },

    setStageKind(stageID){
      this.$store.state.currentStageKind = this.$store.state.receivedData.stages.list.filter((stage) =>{return stage.id == stageID})[0].kind;
    },

    onCreate(){
      if(this.$store.state.selectedObject.total_extra_seats.toString().length == 0) this.$store.state.selectedObject.total_extra_seats = 0;
      if(this.editPricelist){
        this.clearEmptyPrices();
        this.editPricelist = false;
      }

      this.formSubmitted();
      if(this.passed){
        if(this.createDialog){
          this.$store.state.selectedObject.pricelist_data = this.$store.state.receivedData.pricelistsList.list.filter((pricelist) => {return pricelist.id == this.$store.state.selectedObject.pricelist})[0].data;
        }

        this.createOrUpdate();
        this.stageChanged = this.pricelistChanged = false;
        this.$store.dispatch('setActiveTab', 'performances');
      }
    },

    async showTheatre(theatre){
      this.setStageKind(theatre.stage);
      this.$store.state.selectedObject = JSON.parse(JSON.stringify(theatre));
      await this.$store.dispatch('getTheatre', {url: `${this.$store.state.urls.performances}${theatre.id}/`});
      this.detailsVisible = true;
      this.pageY = this.window.pageYOffset;
      this.body.style.overflow = 'hidden';
      this.window.scrollTo(0,0);
      //this.$store.dispatch('setActiveTab', 'ticketTheatre');
    },

    copyToClipboard(url){
      let input = this.document.querySelectorAll('.copy-input')[0];
      input.value = url;
      input.select();
      this.document.execCommand('copy');
    },

    async filterTransactions(){
      this.$store.state.pageLoaded = false;
      this.searched = true;
      let filter = {}
      if(this.filter == 'date') filter['date'] = this.period;
      if(this.filter == 'play') filter['play'] = this.playID;
      filter['active'] = this.isActive;
      await this.$store.dispatch('getPerformances', filter)
      this.$store.state.pageLoaded = true;
    },

    async clear(){
      this.$store.state.pageLoaded = false;
      await this.$store.dispatch('getPerformances');
      this.searched = false;
      this.$store.state.pageLoaded = true;
    }
  },

  watch:{
    editDialog(value){
      if(value){
        let key = null;
        let acceptable = ['published', 'total_extra_seats', 'id', 'start_time', 'activity', 'is_cancelled', 'is_live', 'live_price'];
        this.$store.state.selectedObject = JSON.parse(JSON.stringify(this.selectedPerformance));
        for(key in this.$store.state.selectedObject){
          if(!acceptable.includes(key)) delete this.$store.state.selectedObject[key];
        }

        this.requiredFields = ['start_time'];
        this.objectsToValidate = [this.$store.state.selectedObject]
      }
    },

    createDialog(value){
      if(value){
        this.emptyPerformance = JSON.parse(JSON.stringify({
          play: '',
          stage: '',
          pricelist: '',
          start_time: '',
          published: false,
          pricelist_data: {},
          rows: {},
          subscriptions: [],
          total_extra_seats: 0,
        }));

        this.requiredFields = [
          'play',
          'stage',
          'pricelist',
          'start_time',
          'pricelist_data',
          'season',
        ]

        this.$store.state.selectedObject = JSON.parse(JSON.stringify(this.emptyPerformance));
        this.objectsToValidate = [this.$store.state.selectedObject]
      }
    },

    detailsVisible(value){
      if(!value){
        this.body.style.overflow = 'auto';
        this.window.scrollTo(0, this.pageY)
      }
    },

    editCreateDialogVisible(value){
    },

    isPageLoaded(value){
      if(value) this.detailsVisible = false;
      if(value && this.play == ''){
        this.emptyPerformance.play = this.$store.state.receivedData.plays.list[0].id;
        this.emptyPerformance.stage = this.$store.state.receivedData.stages.list[0].id;
        this.emptyPerformance.season = this.$store.state.receivedData.seasonsList.list[0].id;
        this.emptyPerformance.pricelist = this.$store.state.receivedData.pricelistsList.list[0].id;
        this.playID = this.$store.state.receivedData.plays.list.length > 0 ? this.$store.state.receivedData.plays.list[0].id : '';
      }
    }
  }
}
</script>

<style lang="scss">
.vdatetime{
  margin-bottom: 0;
  padding-bottom: 0;
  margin-top: -16px;
  font-family: 'Roboto';

  & + label{
    top: 0;
    font-size: 12px;
  }
}

.theatre-tickets-dialog{
  .legend{
    ul{
      margin: 0 auto;
    }
  }
}

.vdatetime-input{
  height: 32px;
  padding: 0;
  display: block;
  -webkit-box-flex: 1;
  flex: 1;
  border: none;
  background: none;
  transition: .4s cubic-bezier(.25,.8,.25,1);
  transition-property: font-size,padding-top,color;
  font-family: inherit;
  font-size: 16px;
  line-height: 32px;
}

.vdatetime-popup__header{
  padding: 20px 30px 30px;
}

.vdatetime-calendar__month__day--selected > span > span,.vdatetime-calendar__month__day--selected > span > span, .vdatetime-popup__header{
  background: #448aff;
}

.vdatetime-calendar__month__day.vdatetime-calendar__month__day--selected > span > span:hover{
  background-color: #448aff
}

.vdatetime-popup__actions__button{
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
}

.vdatetime-popup__actions__button--cancel{
  color: rgba(0, 0, 0, 0.87)
}

.vdatetime-popup__actions__button--confirm{
  color: #448aff;
}

.vdatetime-time-picker__item{
  transition: none;
}

.vdatetime-time-picker__item:hover, .vdatetime-time-picker__item--selected:hover{
  font-size: 20px;
  color: #448aff;
}

.vdatetime-time-picker__item--selected{
  color: #448aff;
}

.md-select.md-disabled{
  opacity: 0.7;
}

.performance-dialog{
  z-index: 999999;
  overflow-y: scroll;
  .md-card{
    width: 1024px;
    min-height: auto;
  }
}

.md-table-content tr.cancelled {
  background-color: #ffe5e5;
}

input[disabled="disabled"]{
  -webkit-text-fill-color: #ddd !important;
}

.md-field.md-disabled:after{
  opacity: 0.2
}

</style>

<style lang="scss" scoped>

.pricelist-table-inner{
  max-width: 1430px;
  margin: 50px auto 0;
}

.theatre-dialog{
  width: 100%;
  min-height: 100vh;
  max-width: 100%;
  overflow-y: scroll;

  .md-toolbar.md-theme-default .md-title{
    color: rgba(0,0,0,0.87);
  }

  .theatre-container{
    min-height: calc(100vh - 130px);
    width: calc(100% - 400px);
    .theatre-seats{
      width: 100%;
    }
    .theatre-seats-holder{
      min-height: calc(100vh - 250px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/Performances.vue